var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopping-cart-tips"},[_c('p',{staticClass:"tips-text"},[_vm._v(_vm._s(_vm.tipsText))]),_vm._v(" "),_c('i',{staticClass:"iconfont icon-guanbixiao",on:{"click":_vm.event_closeTips}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-00ea6bd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MTips/index.vue
// module id = null
// module chunks = 